/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/chip/custom-elements';

import { defineCustomElement as defineOsdsChip } from '@ovhcloud/ods-stencil/components/chip/custom-elements/osds-chip.js';


export const OsdsChip = /*@__PURE__*/ defineContainer<JSX.OsdsChip>('osds-chip', defineOsdsChip, [
  'color',
  'contrasted',
  'disabled',
  'flex',
  'removable',
  'selectable',
  'size',
  'variant'
]);

